import { spawn } from "node:child_process";
import {
  LEGACY_WAKELOOP_CLI_CONTEXT_ENV_KEY,
  resolveCliContext,
  WAKELOOP_CLI_CONTEXT_ENV_KEY,
} from "../config/session-profile";

export function rerunCurrentCommandWithEnv(input: {
  argv: string[];
  env: Record<string, string>;
}): Promise<number> {
  const scriptPath = input.argv[1];
  if (!scriptPath) {
    return Promise.resolve(1);
  }

  const cliContext = resolveCliContext();
  const baseEnv = { ...process.env };
  if (cliContext) {
    delete baseEnv[LEGACY_WAKELOOP_CLI_CONTEXT_ENV_KEY];
    baseEnv[WAKELOOP_CLI_CONTEXT_ENV_KEY] = cliContext.cliContextId;
  }
  const childEnv = {
    ...baseEnv,
    ...input.env,
  };
  if (cliContext) {
    delete childEnv[LEGACY_WAKELOOP_CLI_CONTEXT_ENV_KEY];
    childEnv[WAKELOOP_CLI_CONTEXT_ENV_KEY] = cliContext.cliContextId;
  }

  return new Promise<number>((resolve) => {
    const child = spawn(
      process.execPath,
      [scriptPath, ...input.argv.slice(2)],
      {
        stdio: "inherit",
        env: childEnv,
      }
    );
    child.once("error", () => resolve(1));
    child.once("exit", (code, signal) => {
      if (signal) {
        resolve(1);
        return;
      }
      resolve(code ?? 0);
    });
  });
}
